<template>
  <div>
    <lk-modal
      v-model="showModal"
      title="单据订正"
      width='780'
      :mask-closable="false"
      :closable="false"
      @on-visible-change='reset'
    >
      <lk-form
        :model="config"
        :label-width="100"
      >
        <lk-form-item v-for="(dataItem, index) in config.formItem" :label="dataItem.name || ''" :key="index">
         <!-- 文本显示 -->
         <div v-if="dataItem.type === 'txt' && config.formData[dataItem.key] !== ''">
            <span>{{config.formData[dataItem.key]}}</span>
            <span v-if="dataItem.otherTxt">
              <span :class="dataItem.otherTxtClass">{{dataItem.otherTxt}}</span>
            </span>
          </div>
          <!-- 原预收核销 -->
          <div v-if="dataItem.type === 'ArrayTxt' && config.formData[dataItem.key]">
            <span v-for="(spanItem, idx) in config.formData[dataItem.key]" :key="idx">
              <span>{{spanItem}}</span><br>
            </span>
          </div>
          <div v-if="dataItem.type === 'depositAmount' && refundData != undefined && refundData.length>0">
            <span v-for="(spanItem, idx) in config.formData[dataItem.key]" :key="idx">
              <span>{{spanItem}}</span><br>
            </span>
          </div>
          <!-- 更新销项税率 -->
          <div v-if="dataItem.type === 'table' && config.formData[dataItem.tableName]">
            <lk-table
              border
              class="table"
              :columns="config.formData[dataItem.tableName].columns"
              :data="config.formData[dataItem.tableName].tableData"
            ></lk-table>
          </div>
          <!-- 新预收核销 -->
          <div class='infoList' v-if="dataItem.type === 'deposit'">
              <div
                class='infoItem'
                v-for="(item,index) in config.subParams.advanceAmountList"
                :key="index"
              >
                <div>
                  <label><span>选择预收单：</span></label>
                  <lk-select
                    class="depositItem"
                    style="width: 200px"
                    v-model="item.id"
                    clearable
                  >
                    <lk-option v-for="(deposit,i) in depositList" :value='deposit.id' :key="i" :disabled="isDisabled(deposit.id)">
                      {{deposit.createTime +' &nbsp; '+ deposit.deposit+'元&nbsp; '+deposit.paymentUserName +' &nbsp; '+ deposit.paymentUserPhone}}
                    </lk-option>
                  </lk-select>
                </div>
                <div style="display:flex;">
                  <label><span>核销金额：</span></label>
                  <NumberInput
                    type="canMinus"
                    placeholder="收款金额"
                    style="width:90%"
                    size=''
                    v-model="item.amount"
                  ></NumberInput>
                  <lk-button
                    type="text"
                    size="small"
                    @click="toDeleteAReBill(index)"
                  >删除</lk-button>
                </div>
              </div>
              <lk-button class="infoBtn" type="text" @click="addNewReceiveBill">+新增预收单</lk-button>
          </div>
          <!-- 新其他收款 -->
          <div v-if="dataItem.type === 'payment'" class="paymentMethod">
            <template style='display: flex' v-for="(item,index) in config.subParams.paymentList" >
              <lk-form-item :label="item.proceedsTypeName+'：'" :label-width="84" :key="index">
                <NumberInput
                  :type='item.proceedsTypeId===23?"canMinus":"price"'
                  size=''
                  v-model="config.subParams.paymentList[index].amount"
                  placeholder="收款金额"
                  style="width: 200px;"
                >
                </NumberInput>
              </lk-form-item>
            </template>
          </div>
          <!-- 收款方式-可选择类型 -->
          <div v-if="dataItem.type === 'selectPayment'">
            <div class="selectPayment">
              <lk-select
                class="depositItem"
                style="width: 200px"
                v-model="config.subParams.selectPayment.id"
                clearable
              >
                <lk-option v-for="(item,i) in config.subParams.paymentList" :value='item.proceedsTypeId' :key="i">
                  {{item.proceedsTypeName}}
                </lk-option>
              </lk-select>
              <div class="paymentAmount">
                <label><span>{{dataItem.otherTxt}}：</span></label>
                <NumberInput
                  type="canMinus"
                  placeholder="收款金额"
                  style="width:200px"
                  size=''
                  v-model="config.subParams.selectPayment.amount"
                ></NumberInput>
              </div>
            </div>
          </div>
          <div v-if="dataItem.type === 'selectRefund'">
            <div class="selectPayment">
              <lk-select
                class="depositItem"
                style="width: 200px"
                v-model="config.subParams.selectPayment.id"
                clearable
              >
                <lk-option v-for="(item,i) in config.subParams.paymentList" :value='item.proceedsTypeId' :key="i">
                  {{item.proceedsTypeName}}
                </lk-option>
              </lk-select>
            </div>
          </div>
          <!-- 退款方式 -->
          <div v-if="dataItem.type === 'morePayment'">
            <div v-for="(refundItem, index) in refundList" :key="index">
              <div class="refundMethod">
                <lk-select placeholder='请选择退款方式' class="refundInput" v-model="refundItem.proceedsTypeId" label-in-value @on-change="handleProceedsTypeChange(refundItem, index)">
                  <lk-option v-for="item in config.subParams.paymentList" :value="item.proceedsTypeId" :key="item.proceedsTypeName">{{ item.proceedsTypeName }}
                    </lk-option>
                </lk-select>
                &nbsp;
                <lk-input-number style="width:calc(50% - 25px)" v-model.trim="refundItem.amount" :max="999999999.99" :min="0" :active-change="false" placeholder='请输入退款金额' clearable @on-change="priceChange" :precision="2" ></lk-input-number>
                <lk-button v-if="index!=0" type="text-primary" @click="deleteRefund(index)">删除</lk-button>
                <div class="emptySpan" v-else></div>
              </div>
            </div>
            <span v-if="refundList.length < 5" class="addButton" @click="addNew">+添加退款方式</span>
          </div>
          <div v-if="dataItem.type === 'proceedList' && refundData != undefined && refundData.length>0">
            <lk-table :data="refundData" :columns="refundColum" class="rejectTable" border/>
          </div>
          <!-- 订正原因 -->
          <div v-if="dataItem.type === 'reason'">
            <lk-input
              :maxlength='500'
              placeholder='请说明原因'
              clearable
              v-model.trim="config.subParams.reason"
              style="width: 91%"
            ></lk-input>
          </div>
        </lk-form-item>
      </lk-form>
      <div slot="footer">
        <lk-button @click="cancel">取消</lk-button>
        <lk-button type="primary" @click="handlerSubmit">提交</lk-button>
      </div>
    </lk-modal>
  </div>
</template>

<script>
import utils from '../../libs/utils';
import afterSale from '../../services/afterSale';

export default {
  name: 'revisionModal',
  props: {
    showRevisionModal: {
      type: Boolean,
      default: false,
    },
    deposits: {
      type: Array,
      default: () => [],
    },
    formConfig: {
      type: Object,
    },
    formInfo: {
      type: Object,
      default: () => {},
    },
  },
  model: {
    prop: 'showRevisionModal',
    event: 'change',
  },
  computed: {
    paymentedAmount() {
      let amount = 0;
      this.config.subParams.paymentList.forEach((item) => {
        if (item.amount) {
          amount += Number(item.amount);
        }
      });
      return amount;
    },
    advanceAmount() {
      let amount = 0;
      this.config.subParams.advanceAmountList.forEach((item) => {
        if (item.amount && item.id) {
          amount += Number(item.amount);
        }
      });
      return amount;
    },
    selectAmount() {
      let amount = 0;
      const selectPayment = this.config.subParams.selectPayment;
      if (selectPayment.amount && selectPayment.id) {
        amount += Number(selectPayment.amount);
      }
      return amount;
    },
  },
  watch: {
    showRevisionModal: {
      handler() {
        this.showModal = this.showRevisionModal;
      },
      deep: true,
    },
    formConfig: {
      handler() {
        if (this.formConfig.formData.bizType == 2) {
          this.getPayMethod(this.formConfig.formData.orderCode, this.formConfig.formData.id);
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      refundTotal: 0, // 退款总金额
      showModal: false,
      config: {},
      depositList: [],
      refundList: [],
      refundData: [],
      refundColum: [
        {
          title: '收款单号',
          minWidth: 116,
          key: 'depositCode',
        },
        {
          title: '付款人',
          minWidth: 116,
          key: 'paymentUserName',
        },
        {
          title: '联系方式',
          minWidth: 116,
          key: 'paymentUserPhone',
        },
        {
          title: '核销金额',
          minWidth: 116,
          key: 'verificationAmount',
        },
        {
          title: '已退款金额',
          minWidth: 116,
          key: 'refundedAmount',
          render: (h, params) => h('span', params.row.refundedAmount ? params.row.refundedAmount : '0'),
        },
        {
          title: '退款中金额',
          minWidth: 116,
          key: 'refundingAmount',
          render: (h, params) => h('span', params.row.refundingAmount ? params.row.refundingAmount : '0'),
        },
        {
          title: '可退款金额',
          minWidth: 116,
          key: 'ableToRefundAmount',
        },
        {
          title: '退款金额',
          minWidth: 130,
          key: 'refundAmount',
          render: (h, { row, index }) => h('lk-input-number', {
            on: {
              'on-change': (e) => {
                this.refundData[index].refundAmount = e;
                if (e * 1 > this.refundData[index].verificationAmount * 1) {
                  this.$Message.error('预收退款金额不能大于可退款金额');
                  return;
                }
                this.priceChange();
              },
            },
            props: {
              value: row.refundAmount,
              placeholder: '退款金额',
              min: 0,
              precision: 2,
              max: row.ableToRefundAmount * 1,
              'active-change': false,
            },
          }),
        },
      ],
    };
  },
  methods: {
    handleProceedsTypeChange(item, index) {
      if (!item.proceedsTypeId || item.proceedsTypeId < 0) {
        this.clearIndexMethod(index);
        return;
      }
      const hasCount = this.refundList.filter(fItem => fItem.proceedsTypeId == item.proceedsTypeId).length;
      this.refundList[index].proceedsTypeName = this.config.subParams.paymentList.filter(fItem => fItem.proceedsTypeId == item.proceedsTypeId)[0].proceedsTypeName;
      if (hasCount > 1) {
        this.$Message.error('该退款方式已选中，请重新选择');
        this.clearIndexMethod(index);
      }
    },
    clearIndexMethod(index) {
      const tempList = utils.deepClone(this.refundList);
      this.refundList = [];
      tempList[index] = { proceedsTypeId: -1, amount: null, proceedsTypeName: '' };
      setTimeout(() => { // 设置延迟执行才可以，不知道什么原因
        this.refundList = tempList;
        this.priceChange();
      }, 1);
    },
    priceChange() {
      let sum = 0;
      for (let i = 0; i < this.refundList.length; i++) {
        if (this.refundList[i].amount && this.refundList[i].amount != undefined) {
          sum += this.refundList[i].amount * 1;
        }
      }
      for (let i = 0; i < this.refundData.length; i++) {
        if (this.refundData[i].refundAmount != undefined && this.refundData[i].refundAmount) {
          sum += this.refundData[i].refundAmount * 1;
        }
      }
      this.refundTotal = utils.toFixed(sum, 2, true);
    },
    deleteRefund(index) {
      this.refundList.splice(index, 1);
      this.priceChange();
    },
    getPayMethod(value, saleRefundId) {
      afterSale.getPayMethod({ orderNo: value, saleRefundId }).then((res) => {
        if (res.data.status == 200) {
          if (res.data.data.financeDepositInfos != undefined) {
            this.refundData = res.data.data.financeDepositInfos;
            this.refundData.forEach((item) => {
              if (!item.refundAmount) {
                item.refundAmount = null;
              }
            });
          } else {
            this.config.formItem = this.config.formItem.filter(item => item.type != 'depositAmount' && item.type != 'proceedList');
          }
          if (res.data.data.saleOrderProceeds != undefined) {
            this.refundList = res.data.data.saleOrderProceeds;
          } else {
            this.refundList = [{ proceedsTypeId: null, amount: null }];
          }
        } else {
          this.$Message.error(res.data.error);
        }
        this.loading = false;
        this.priceChange();
      });
    },
    addNew() {
      const temp = { proceedsTypeId: null, amount: null };
      if (this.refundList.length <= 0) {
        this.refundList = [{ proceedsTypeId: null, amount: null }];
      } else {
        this.refundList.push(temp);
      }
    },
    reset(show) {
      if (show) {
        this.config = utils.deepClone(this.formConfig);
        this.depositList = this.deposits;
      }
    },
    cancel() {
      this.$emit('change', false);
      this.showModal = false;
    },
    handlerSubmit() {
      if (this.formInfo.bizType == 2) {
        const saleOrderProceeds = [];
        let hasProceeds = true;
        this.refundList.forEach((item) => {
          const methodData = {};
          methodData.proceedsTypeId = item.proceedsTypeId;
          if (item.proceedsTypeName == '' || item.proceedsTypeName == undefined) {
            if (this.refundData.length <= 0) { // 没有预收款，必须选一个退款方式
              hasProceeds = false;
            }
          }
          if (item.proceedsTypeName != '' && item.proceedsTypeName != undefined) {
            methodData.proceedsTypeName = item.proceedsTypeName;
            methodData.amount = item.amount;
            saleOrderProceeds.push(methodData);
          }
        });
        if (!hasProceeds) {
          this.$Message.error('请选择退款方式');
          return;
        }
        if (this.refundTotal != this.config.formData.amount) {
          this.$Message.error('退款金额不等于退货金额，请检查后重新提交');
          return;
        }
        this.config.subParams.refundList = saleOrderProceeds;
        this.config.subParams.refundData = this.refundData;
      }
      const {
        proceedsAmount,
        amount,
      } = this.config.formData;
      let finalAmount = proceedsAmount;
      if (this.formInfo.bizType == 2) {
        finalAmount = amount;
      }
      if (this.formInfo.bizType == 4) {
        this.config.subParams.selectPayment.amount = finalAmount;
      } else if (this.formInfo.type && this.formInfo.type === 1 && this.formInfo.bizType != 2) {
        const total = this.paymentedAmount + this.advanceAmount + this.selectAmount;
        if (Number(utils.toFixed(finalAmount, 2, true)) !== Number(utils.toFixed(total, 2, true))) {
          this.$Message.error('新收款总额必须等于原收款总额');
          return;
        }
      }
      this.$emit('update:formConfig', this.config);
      this.$emit('change', false);
      this.showModal = false;
      this.$emit('revisionSave');
    },
    isDisabled(value) {
      const obj = this.config.subParams.advanceAmountList.find(item => item.id === value);
      if (obj) {
        return true;
      }
      return false;
    },
    toDeleteAReBill(index) {
      if (this.config.subParams.advanceAmountList.length <= 1) {
        this.$Message.error('不可删除');
        return;
      }
      this.config.subParams.advanceAmountList.splice(index, 1);
    },
    addNewReceiveBill() {
      if (this.config.subParams.advanceAmountList.length >= 5) {
        this.$Message.error('最多添加5条预收单');
        return;
      }
      this.config.subParams.advanceAmountList.push({
        type: 2,
      });
    },
  },
  created() {
    this.config = utils.deepClone(this.formConfig);
    this.depositList = this.deposits;
  },
  mounted() {
  },
};

</script>
<style lang="less" scoped>
  .infoList {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    line-height: 24px;
    .infoItem {
      display: flex;
    }
    .infoItem>div {
      display: flex;
      width: 300px;
      margin-bottom: 8px;
      label {
        text-align: right;
        display: flex;
        align-items: center;
        flex-shrink: 0;
        justify-content: flex-end;
        span {
          flex-shrink: 0
        }
      }
    }
    .infoBtn {
      margin-left: -18px;
    }
  }
  .posStatus {
    color: #57a3f3;
    font-weight: 500;
    margin-left: 20px;
  }
  .paymentMethod {
    display: flex;
    flex-wrap: wrap;
    /deep/ .ivu-form-item {
      display: flex;
      height: 44px;
    }
    /deep/ .ivu-form-item:nth-child(2n) {
      margin-left: 20px;
    }
  }
.selectPayment {
  display: flex;
  .paymentAmount {
    display: flex;
    label {
      width: 60px;
      margin-left: 30px;
    }
  }
}
.table {
  margin-left: -65px;
}
.addButton {
  font-weight: 500;
  color: #2d8cf0;;
}
.refundMethod {
  margin-bottom: 6px;
  display: flex !important;
  width: 390px;
}
.emptySpan {
  width: 95px;
}
.refundInput {
  display: inline !important;
}
</style>
